import React, { } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, ButtonGroup, IconButton } from '@mui/material';
import AddBoxIcon from '@mui/icons-material/AddBox';

const columns = [
  { id: 'id_area', label: '#', minWidth: 100, align: 'left', },
  { id: 'desArea', label: 'Descripción', minWidth: 200, align: 'left', },
  { id: 'codArea', label: 'Código', minWidth: 120, align: 'left', },
  { id: 'actions', label: 'Acciones', minWidth: 120, align: 'left', },
];

const BodyAreas = (props) => {
  const {handleOpen, areas, setInfoArea, } = props;

  return (
    <div className='page-body-main'>
      <div className='page-body__table' style={{ overflow: 'hidden' }}>
        <div className='page-body-table'>
          <TableContainer className='table-height'>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {areas?.map((record, indexRow) => {
                  return (
                    <TableRow hover role="checkbox" tabIndex={-1} key={"row" + indexRow}>
                      {columns.map((column, indexColumn) => {
                        const value = record[column.id];
                        return (
                          <TableCell key={'col' + indexColumn} align={column.align}>
                            {column.id === 'actions' ?
                              <ButtonGroup
                                disableElevation
                                variant="contained"
                                aria-label="Disabled elevation buttons"
                              >
                                <IconButton aria-label="delete" size="small" style={{ border: `solid 1px green` }}
                                  onClick={() => { setInfoArea(record); handleOpen(); }}
                                  title='Agregar supervisor'
                                >
                                  <AddBoxIcon color={'success'} fontSize={'12px'} />
                                </IconButton>
                              </ButtonGroup>
                              : value}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </div>
  );
}
export default BodyAreas;